import {BaseBean} from "../shared/base-bean";

export class CodigoBarras extends BaseBean {

    public clienteSg: number;
    public cnpjClienteSg: string;
    public codigoPro: number;
    public codBarra: string;

    constructor(id?: number,
                clienteSg?: number,
                cnpjClienteSg?: string,
                codigoPro?: number,
                codBarra?: string) {
        super(id);
        this.clienteSg = clienteSg;
        this.cnpjClienteSg = cnpjClienteSg;
        this.codigoPro = codigoPro;
        this.codBarra = codBarra;
    }

}
